module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAICAYAAADN5B7xAAAAuklEQVQoU2MsqGw98v//f2sG4sAxxvzKlvMM/xkMiFL/n+ECY0FFg9L//8wnGRgZRfBq+v//DSPjX3NGkKL88hY7BkaG3QwMDGw4NP1i+M/gOrGz5hBYAwgUVLQm/Wf4PxebBkYGxuQJHdXzQHJwDWCbKlp7GBj+F6NqYuyd2FFdAhND0dDQ0MD07gfLJkYGBm+Qgv8MDFuFOP74NTQ0/MOqASRYVtbJ+5P5D8g/DOx/WVy7uso/I9sIALzaOfylXfylAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/down-arow.png
// module id = vRHk
// module chunks = 1